import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  const { t, lang } = useLanguage();
  useSeo({
    title: "Seite nicht gefunden, Wim Jansen Delgado",
    description: "Diese Seite existiert nicht.",
    path: "/404",
    robots: "noindex",
  });

  return (
    <div data-testid="not-found-page">
      <section className="mx-auto flex min-h-[70vh] max-w-7xl flex-col justify-center px-6 pt-28 md:px-12 lg:px-16">
        <Reveal>
          <p className="mb-4 font-mono text-sm uppercase tracking-[0.15em] text-smoke">404</p>
          <h1 className="font-serif text-5xl font-light tracking-tight text-bone md:text-7xl">
            {lang === "en" ? "This page has wandered off." : "Diese Seite ist verzogen."}
          </h1>
          <Link
            to={lang === "en" ? "/en" : "/"}
            data-testid="not-found-home-link"
            className="mt-10 inline-flex w-fit items-center gap-3 border border-ember-deep bg-ember-deep px-10 py-4 font-mono text-[11px] uppercase tracking-[0.25em] text-obsidian transition-colors duration-300 hover:bg-transparent hover:text-ember-deep"
          >
            {lang === "en" ? "Back to the start" : "Zur Startseite"}
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
